import { offlineActionCreator } from "actions/lib";

import { REFRESH_INTERVAL, SERVER_HEARTBEAT } from "constants/actionTypes";

export function updateRefreshInterval(refreshIntervalMs) {
  return {
    type: REFRESH_INTERVAL.ACTION,
    refreshIntervalMs,
  };
}

const urlCreator = () => `/v2/heartbeat/`;

export const ServerHeartbeatAction = offlineActionCreator(
  SERVER_HEARTBEAT,
  () => {},
  urlCreator,
  false,
);
